<mat-progress-bar [value]="value" [mode]="mode"></mat-progress-bar>